import "./CollectionListItem.scss";

export default {
  props: {
    data: Object,
  },
};
